import ReadingPaneOptionState from '../store/schema/ReadingPaneOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';

export interface SelectLoadMessageOnSignOnOptionState {
    optionState: ReadingPaneOptionState;
}

export default select<SelectLoadMessageOnSignOnOptionState>({
    optionState: () => store,
})(
    action('selectLoadMessageOnSignOnOption')(function selectLoadMessageOnSignOnOption(
        loadMessage: boolean,
        state?: SelectLoadMessageOnSignOnOptionState
    ) {
        let { optionState } = state;
        optionState.loadMessageOnLogOn = loadMessage;
    })
);
